/* unplugin-vue-components disabled */import { render } from "./logic.vue?vue&type=template&id=bbc6612c&scoped=true"
import script from "./logic.vue?vue&type=script&lang=js"
export * from "./logic.vue?vue&type=script&lang=js"

import "./logic.vue?vue&type=style&index=0&id=bbc6612c&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc6612c"]])

export default __exports__